namespace Gordic.Epk.WebControls.Sidebar {

    export class GEpkAttachment {

        /** typ posuvu v náhledovačce */
        private scrollMode: Gordic.Components.FilePreview.GPdfEngineScrollMode | undefined = undefined;


        private cnt: GContentType<any>;

        constructor(cnt: GContentType<any>) {
            this.cnt = cnt;
            if (cnt.globalSettings != null) {
                this.scrollMode = cnt.globalSettings.get("Global.Epk.AppSettings.ScrollMode");
            }
        }

        private tempRow?: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null;

        public create(activeRow: Gordic.Wfl.Interface.GPodpisovaKnihaDto, attachFunc: Function, grid?: JQuery<HTMLElement>) {
            var attachment = $("<div class='epk-attachment'>");
            attachFunc(attachment);
            return {
                icon: "gi-nahled",
                customDiv: attachment,
                minWidth: 275,
                id: "panelAttachmentsGrid",
                caption: "jres:32000001",				//RC 32000001 : Náhled
                leaf: "jres:32000001",					//RC 32000001 : Náhled
                open: (ev, obj) => {
                    if (grid != null)
                        activeRow = grid.ggrid("activeRow");
                    this.open(activeRow, attachment);
                },
            } as GSideBarPanelOptions;
        }

        public open(activeRow: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null, attachment: JQuery<HTMLElement>) {

            if (activeRow == null || activeRow.ixp == null) {
                this.tempRow = null;
                if (attachment.hasClass("gattachment") === true) {
                    this._disableAttach(attachment, true);
                }
            }
            else {
                var ixp = activeRow.ixp;
                var ixb_elp = activeRow.ixb_elp == null ? "" : activeRow.ixb_elp;
                if (attachment.hasClass("gattachment") === false) {
                    this._createAttach(attachment, ixp, ixb_elp, activeRow);
                }
                else {
                    // jinak volám opakovan a nemusím znovu vykreslovat
                    if (activeRow !== this.tempRow)  
                        this._updateAttach(attachment, ixp, ixb_elp, activeRow);
                }
                this.tempRow = activeRow;
            }
        }

        private _createAttach(element: JQuery<HTMLElement>, ixp: string, ixb_elp: string, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null) {

            var ser_cislo: number | null = null;

            if (row != null) {      
                ser_cislo = row.ser_cislo!;
                if (row.history === true) {
                    var t = $("<div>").appendTo(element);
                    t.gflashpanel({ 
                        id: "idAttachmentSpecificVersion",
                        content: "jres:32001065", //RC 32001065 : Náhled je z doby vyřízení žádosti.
                    });
                }
            }

            this.tempRow = row;
           
            element.gattachment({
                
                disabled: false,
                emptyMessage: "jres:32000724",	//RC 32000724 : Náhled není k dispozici.
                ixp: ixp,
                ser_cislo: ser_cislo,
                serviceContent: "Gordic.Epk.WebControls.GEpkAttachmentService",
                ixb_elp: ixb_elp,
                filePreviewOptions: {
                    customDownload: (input) => {
                        return this.customDownload(input, this.tempRow);
                    }
                },
                displayEngineOptions: {
                    pdfEngine: {
                        scrollMode: this.scrollMode // Gordic.Components.FilePreview.GPdfEngineScrollMode.Horizontal
                    }
                }
            });
        }

        //todo: nešlo by nějak vytáhnout gattachmentdto přímo z komponenty?

        public customDownload(input: { ixp?: string, porCislo?: number }, row?: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null) {

            //todo: je potřeba brát v potaz správnou verzi el. obrazu / přílohy

            const cnt = this.cnt;

            if (input == null || input.ixp == null)
                return $.Deferred().resolve().promise();
            var dfd = $.Deferred();

            if (input.porCislo == null) {
                // EL. OBRAZ
                if (row != null && row.history === true) {
                    Gordic.Wfl.AttachmentUtils.GetFavoriteFromTimeOfSettlement(cnt, input.ixp, row)
                        .then((dto) => {
                            return Gordic.Wfl.AttachmentUtils.OpenAttachment(cnt, dto, true);
                        })
                        .done(() => {
                            setTimeout(dfd.resolve, 2000);
                        })
                }
                else {
                    Gordic.Wfl.AttachmentUtils.GetFavorite(cnt, input.ixp)
                        .then((dto) => {
                            return Gordic.Wfl.AttachmentUtils.OpenAttachment(cnt, dto, true, false)
                        })
                        .done((args) => {
                            setTimeout(dfd.resolve, 2000);
                        })
                }
            }
            else {
                // EL. PŘÍLOHY
                if (row != null && row.history === true) {
                    Gordic.Wfl.AttachmentUtils.GetAttachmentFromTimeOfSettlementByPorCislo(cnt, input.ixp, input.porCislo, row)
                        .then((dto) => {
                            return Gordic.Wfl.AttachmentUtils.OpenAttachment(cnt, dto, true);
                        })
                        .done(() => {
                            setTimeout(dfd.resolve, 2000);
                        })
                }
                else {
                    Gordic.Wfl.AttachmentUtils.GetAttachmentByPorCislo(cnt, input.ixp, input.porCislo)
                        .then((dto) => {
                            return Gordic.Wfl.AttachmentUtils.OpenAttachment(cnt, dto, true);
                        })
                        .done(() => {
                            setTimeout(dfd.resolve, 2000);
                        })
                }
            }              
            return dfd.promise();
        }

        private _updateAttach(element: JQuery<HTMLElement>, ixp: string, ixb_elp: string, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null) {

            var ser_cislo: number | null = null;
            if (row != null)
                ser_cislo = row.ser_cislo!;

            element.gattachment("option", {
                disabled: false,
                ixp: ixp,
                ixb_elp: ixb_elp,
                ser_cislo: ser_cislo
            });
        }

        private _disableAttach(element: JQuery<HTMLElement>, disabled: boolean) {
            element.gattachment("option", {
                disabled: disabled
            });
        }

    }

}

